import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import {
  TicketGroupPathParamsValidationSchema,
  TicketTypeEventIdInputSchema,
} from '../ticket-type/params';

export { TicketGroupPathParamsValidationSchema };

export const TicketGroupEventIdInputSchema = TicketTypeEventIdInputSchema;

export const TicketGroupIdInputSchema = ObjectIdStringValidationSchema.meta({
  description:
    "The ID of the ticket group. get_event lists the event's groups under `ticketGroups[].id`.",
});

export const TICKET_GROUP_TRIGGER_ID_DESCRIPTION =
  'ID of another ticket group on the same event whose sale end or sell-out makes this group available. Required when `availabilityBehavior` is `after_ticket_sale_ends`, `after_ticket_sold_out` or `after_ticket_ends_or_sold_out`. Find it under `ticketGroups[].id` in get_event.';
